import { Button, ButtonProps } from '@mui/material';
import { useRef } from 'react';

import { colors } from 'src/global/styles/colors';

interface UploadButtonProps extends ButtonProps {
  label?: string;
  uploadCallback: (files: FileList) => void;
  multiple: boolean;
  accept?: string;
}

export const UploadButton = (props: UploadButtonProps) => {
  const { label, uploadCallback, multiple, accept, ...rest } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e?.target?.files;
    if (files && files.length > 0) {
      uploadCallback(files);
      // Reset the input value after handling the file
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  };

  return (
    <Button
      component='label'
      sx={{
        height: '56px',
        fontWeight: 500,
        width: 'fit-content',
        backgroundColor: colors.brand300,
        color: 'white',
        padding: '14px 32px !important',
        '&:hover': {
          backgroundColor: colors.brand200,
        },
        ...(rest.sx as object),
      }}
      startIcon={<img src='/icons/common/upload.svg' width={24} height={24} alt='upload' />}
      {...rest}>
      {label}
      <input
        ref={inputRef}
        accept={accept}
        multiple={multiple}
        type='file'
        hidden
        onChange={handleFileChange}
        onClick={e => {
          // Reset the value when clicking the input
          (e.target as HTMLInputElement).value = '';
        }}
      />
    </Button>
  );
};
